import { useEffect } from 'react';

import { clientIdGoogle } from 'app/config/config';
import { logger } from 'shared/infrastructure/logger';
import { gapi } from 'gapi-script';

type GoogleAuthError = { details?: string; error?: string };

type LegacyGoogleApi = {
  auth2: {
    init: (config: { clientId: string; plugin_name: string }) => {
      then: (onInit: () => void, onError: (error: GoogleAuthError) => void) => unknown;
    };
  };
  load: (libraries: string, callback: () => void) => void;
};

// Con este código falla cualquier inicialización del iframe de la librería antigua: origen sin registrar en la consola
// de Google (lo que llega de Edelvives, TANGERINE-FRONTOFFICE-3KM y afines), cookies de terceros bloqueadas… Se ignora
// porque nada usa `gapi.auth2`: Classroom tira de `gapi.client` y `gapi.auth`.
const ORIGIN_NOT_REGISTERED = 'idpiframe_initialization_failed';

const legacyGapi = gapi as unknown as LegacyGoogleApi;

function ignoreInit(): void {
  // Nadie usa la instancia de GoogleAuth: solo interesa tratar el rechazo.
}

function handleInitError(error: GoogleAuthError): void {
  if (error?.error === ORIGIN_NOT_REGISTERED) return;
  logger.warn('Google auth2 init failed', { extra: { error: error?.error } });
}

function useLegacyGoogleAuth(): void {
  useEffect(() => {
    legacyGapi.load('client:auth2', () => {
      legacyGapi.auth2
        .init({
          clientId: clientIdGoogle[globalThis.location.origin],
          plugin_name: 'chat',
        })
        .then(ignoreInit, handleInitError);
    });
  }, []);
}

export default useLegacyGoogleAuth;
